<template>
  <AuthLayout :imageSrc="sideImage">
    <div class="login-page restPWRow flex justify-content-center align-items-center w-full">
      <Card class="resetPWCard md:p-5 w-full md:w-8 lg:w-8">
        <template #title>
          <div class="text-center Paragraph-Medium">
            Log in to iLearnd Tutoring
          </div>
        </template>
        <template #content>
          <div class="flex flex-column justify-content-center align-items-center pt-4 ">
            <Button label="Continue with Google" icon="pi pi-google" iconPos="left"
              class="google-button Paragraph-Medium" @click="googleSign" />
            <label class="pt-4 Caption">or</label>
          </div>
          <div class="flex flex-column align-items-center gap-3 pt-4">
            <label for="username" class="Label align-self-start">Email</label>
            <IconField class="w-full">
              <InputIcon class="pi pi-user" />
              <InputText v-model="username" placeholder="Enter email here" size="small" variant="filled"
                class="w-full" />
            </IconField>
          </div>
          <div class="flex flex-column align-items-center gap-3 pt-4 ">
            <label for="username" class="Label align-self-start"> Password</label>
            <IconField iconPosition="left" class="w-full">
              <InputIcon class="pi pi-lock" />
              <Password v-model="password" toggleMask :feedback="false" placeholder="Enter new password here"
                size="small" variant="filled" class="w-full" />
            </IconField>
          </div>
          <div class="flex justify-content-between align-items-center w-full pt-4">
            <div class="flex items-center gap-2 ">
              <Checkbox class="teal-checkbox" v-model="checked" binary />
              <label class="Caption align-self-center"> Remember me </label>
            </div>
            <div>
              <label class="Caption align-self-center cursor-pointer" @click="ForgotPW"> Forgot password? </label>
            </div>
          </div>
          <div class="flex-column flex align-items-center pt-6">
            <Button label="Login" class="teal-700-button" @click="handleLogin"
              :disabled="username.length < 1 || password.length < 1" />
            <label for="username" class="Caption pt-3">Remember password? <span class="Caption-teal cursor-pointer"
                @click="SignUp">Sign Up</span></label>
          </div>
        </template>
      </Card>
    </div>
  </AuthLayout>
</template>

<script setup>
import Card from 'primevue/card';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import InputText from 'primevue/inputtext';
import Password from 'primevue/password';
import Button from 'primevue/button';
import AuthLayout from "@/layout/AuthLayout.vue";
import Checkbox from 'primevue/checkbox';
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { useAuthStore, setRememberMe } from "@/stores/authStore";
import { notifyError } from '@/utils/notification';
import { isSuspendedMemberError, SUSPENDED_MEMBER_MESSAGE } from '@/utils/subscriptionGuards';

const username = ref("");
const password = ref("");
const authStore = useAuthStore();
const router = useRouter();
const checked = ref(false);
import sideImage from "@/assets/Images/image1.png";

onMounted(async () => {
  await authStore.logout(false);
  const hash = window.location.hash; // "#/login?token=..."
  const queryString = hash.split("?")[1]; // "token=..."
  const urlParams = new URLSearchParams(queryString);
  const token = urlParams.get("token");
  const refreshToken = urlParams.get("refreshToken");
  const user = urlParams.get("user");

  if (token && refreshToken && user) {
    const data = {
      user: JSON.parse(user),
      accessToken: token,
      refreshToken: refreshToken
    }
    console.log(data)
    authStore.handleOAuthData(data);
  }
})

const handleLogin = async () => {
  try {
    // Set remember me based on the checkbox value
    setRememberMe(checked.value);
    await authStore.login(username.value, password.value);
  } catch (error) {
    // Suspended institute member error
    if (isSuspendedMemberError(error)) {
      notifyError("Access unavailable", error.response?.data?.message || SUSPENDED_MEMBER_MESSAGE);
      return;
    }
    const errorMsg = error.response?.data?.message || error.message || "Login failed. Please try again.";
    notifyError("Error", errorMsg);
  }
};
const SignUp = async () => {
  router.push('/onBoarding');
}
const ForgotPW = async () => {
  router.push('/passwordReset');
}
const googleSign = async () => {
  // Google login keeps its current always-remembered behavior (localStorage)
  setRememberMe(true);
  const res = await authStore.googleAuthLogin();
  const url = res.data.data;
  window.location.href = url;
}

</script>
<style scoped>
.resetPWCard {
  border: none;
  box-shadow: none;

}

.google-button {
  background-color: white;
  color: var(--gray-600);
  border: 1px solid #ddd;
  padding: 8px 40px 8px 40px;
}

.google-button:hover {
  background-color: var(--gray-50) !important;
  color: var(--gray-600) !important;
  border: 1px solid #ddd !important;
}
</style>